import { render, staticRenderFns } from "./AgendaTemplate.vue?vue&type=template&id=9295dec8&scoped=true"
import script from "./AgendaTemplate.vue?vue&type=script&lang=ts"
export * from "./AgendaTemplate.vue?vue&type=script&lang=ts"
import style0 from "./AgendaTemplate.vue?vue&type=style&index=0&id=9295dec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9295dec8",
  null
  
)

export default component.exports